//记得在 src\components\lang\zhLoad.js 里面添加对象
const client = {
};
export default client



// WEBPACK FOOTER //
// ./src/page/bd/weighRedFlush/lang/index.zh.js